(() => {
if (!window.customElements || customElements.get('te-template-gallery')) return;
customElements.define('te-template-gallery', class extends HTMLElement {
 connectedCallback() {
  if (this._abort) return;
  const details = this.querySelector('.te-bestsellers__disclosure');
  const summary = details?.querySelector(':scope > summary');
  const panel = details?.querySelector('.te-bestsellers__panel');
  if (!details || !summary || !panel) return;
  this._box = details;
  this._head = summary;
  this._open = details.open;
  this._seq = (this._seq || 0) + 1;
  this._saved = ['height', 'overflow', 'boxSizing'].map(key => details.style[key]);
  this._abort = new AbortController();
  const options = { signal: this._abort.signal };
  this._buttons = [...panel.querySelectorAll('[data-te-collapse]')];
  summary.addEventListener('click', event => {
   event.preventDefault();
   this._change(!this._open);
  }, options);
  this._buttons.forEach(button => {
   button.hidden = false;
   button.addEventListener('click', () => this._change(false, true), options);
  });
  details.addEventListener('toggle', () => {
   if (!this._anim && !this._raf) this._open = details.open;
  }, options);
  this.addEventListener('shopify:block:select', event => {
   const card = event.target instanceof Element && event.target.closest('.te-bestsellers__item');
   if (card && panel.contains(card)) this._change(true);
  }, options);
  if (window.ResizeObserver) {
   this._resize = new ResizeObserver(() => {
    if (this._anim && this._open) this._animate(true, ++this._seq);
   });
   this._resize.observe(panel);
  }
 }
 _restore() {
  ['height', 'overflow', 'boxSizing'].forEach((key, index) => {
   this._box.style[key] = this._saved[index];
  });
 }
 _finish(open) {
  this._anim?.cancel();
  this._anim = null;
  this._box.open = open;
  this._restore();
 }
 _change(open, refocus = false) {
  const seq = ++this._seq;
  this._open = open;
  cancelAnimationFrame(this._raf);
  this._raf = 0;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (refocus) {
   this._head.focus({ preventScroll: true });
   const rect = this._head.getBoundingClientRect();
   if (rect.top < 0 || rect.bottom > innerHeight) {
    this._head.scrollIntoView({ block: 'nearest', behavior: reduced ? 'instant' : 'smooth' });
    if (!reduced) {
     let last = rect.top, stable = 0;
     const start = performance.now();
     const settle = () => {
      if (seq !== this._seq) return;
      const top = this._head.getBoundingClientRect().top;
      stable = Math.abs(top - last) < 0.5 ? stable + 1 : 0;
      last = top;
      if ((stable >= 5 && performance.now() - start > 120) || performance.now() - start > 1200) {
       this._raf = 0;
       this._animate(open, seq);
      } else this._raf = requestAnimationFrame(settle);
     };
     this._raf = requestAnimationFrame(settle);
     return;
    }
   }
  }
  this._animate(open, seq);
 }
 _animate(open, seq) {
  const details = this._box;
  const from = details.getBoundingClientRect().height;
  this._anim?.cancel();
  this._anim = null;
  this._restore();
  details.open = open;
  const to = details.getBoundingClientRect().height;
  if (!details.animate || matchMedia('(prefers-reduced-motion: reduce)').matches || Math.abs(from - to) < 1) {
   this._finish(open);
   return;
  }
  details.open = true;
  Object.assign(details.style, { boxSizing: 'border-box', height: `${from}px`, overflow: 'hidden' });
  const anim = details.animate([{ height: `${from}px` }, { height: `${to}px` }], {
   duration: 280, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards'
  });
  this._anim = anim;
  anim.finished.then(() => {
   if (seq === this._seq) this._finish(open);
  }).catch(() => {});
 }
 disconnectedCallback() {
  if (!this._abort) return;
  ++this._seq;
  this._abort.abort();
  this._abort = null;
  cancelAnimationFrame(this._raf);
  this._raf = 0;
  this._resize?.disconnect();
  this._finish(this._open);
  this._buttons.forEach(button => { button.hidden = true; });
 }
});
})();
